module.exports = "<svg viewBox=\"0 0 26 32\" xmlns=\"http://www.w3.org/2000/svg\"><path id=\"color\" d=\"M25 7h-1.113l-2.775 23.126C20.986 31.176 20.06 32 19 32H7c-1.06 0-1.986-.823-2.112-1.874L2.113 7H1c-.552 0-1-.448-1-1s.448-1 1-1h7V3c0-1.654 1.346-3 3-3h4c1.654 0 3 1.346 3 3v2h7c.552 0 1 .448 1 1s-.448 1-1 1zm-9-4c0-.552-.45-1-1-1h-4c-.55 0-1 .448-1 1v2h6V3zM4.127 7l2.747 22.888c.005.043.083.112.126.112h12c.043 0 .12-.07.126-.112L21.873 7H4.127z\" fill=\"#E92E4B\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/images/svg/trash-red.svg
// module id = XhJL
// module chunks = 89